<template>
    <tr>
        <td><span>{{ index + 1 }}</span></td>
        <td class="code">{{ product.vendor_code }}</td>
        <td class="name">
            <a :title="product.name" :href="'/product/'+product.alias" target="_blank">
                <span>{{ product.name }}</span>
            </a>
        </td>
        <td class="remain text-center">
            <span>{{ product.price | chunk }} (шт)</span>
        </td>
        <td class="price text-center">{{ product.quantity }}</td>
        <td class="totalPrice text-center">{{ product.price * product.quantity | chunk}} тг</td>
    </tr>
</template>

<script>
    import Vue from 'vue';
    import jBox from 'jbox/dist/jBox.all'

    export default {
        props: ['product', 'index'],

        data() {
            return {}
        },

        filters: {
            chunk: function (x) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            },
        },
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/app/pages/order/ProductDefault.vue